import React, { Component } from 'react';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';
import {RedDesign} from './RedDesign';



export class RedPageComponent extends React.Component {

    state = {
        showButton : false
    }
    constructor(props) {
        super(props);
        this.refFileInputSmallImg = React.createRef();
        this.refFileInputBigImg = React.createRef();
        
    }

    componentDidMount() {
        //alert(screen.width)
        if (window.screen.width < 800) {
            this.setState({
                showButton:false
            })
           }
          
    }
    render() {
        return (
            <div>
                <RedDesign
                bgMobileOpacity={this.props.bg_mobile_opacity} 
                 colorPickerBgMobileColorRef={this.props.colorPickerBgMobileColorRef}
                 showColorPickerBgMobileColor={this.props.show_color_picker_bg_mobile_color}
                 bgMobileColor={this.props.bg_mobile_color}
                 bgMobileColorHex={this.props.bg_mobile_color_hex}
                
                frameViewType={this.props.frame_view_type}
                changeFrameView={this.props.changeFrameView}
                 frameHeight={this.props.frame_height}
                 frameWidth={this.props.frame_width}
                 showColorPicker={this.props.showColorPicker}
                 bg2Opacity={this.props.bg2_opacity} 
                 initialContent={this.props.initialContent}
                 bg2ColorHex={this.props.bg2_color_hex}
                 bg1ColorHex={this.props.bg1_color_hex}
                 bg1Opacity={this.props.bg1_opacity}
                 btnColorHex={this.props.btn_color_hex}
                 big_img_src={this.props.big_img_src}
                 small_img_src={this.props.small_img_src}
                 refFirstStage={this.props.refFirstStage}
                 h1ColorHex={this.props.h1_color_hex}
                 h1Color={this.props.h1_color}
                 h2ColorHex={this.props.h2_color_hex}
                 header_text={this.props.header_text}
                 main_text={this.props.main_text}
                 logoColorHex={this.props.logo_color_hex}
                 btnTextColorHex={this.props.btn_text_color_hex}
                 setDefault={this.props.setDefault}
                 colorPickerBtnColorRef={this.props.colorPickerBtnColorRef}
                 showColorPickerBtnColor={this.props.show_color_picker_btn_color}
                 btnColor={this.props.btn_color}
                 handleChangeComplete={this.props.handleChangeComplete}
                 colorPickerBg1ColorRef={this.props.colorPickerBg1ColorRef}
                 showColorPickerBg1Color={this.props.show_color_picker_bg1_color}
                 bg1Color={this.props.bg1_color}
                 
                 colorPickerBg2ColorRef={this.props.colorPickerBg2ColorRef}
                 showColorPickerBg2Color={this.props.show_color_picker_bg2_color}
                 bg2Color={this.props.bg2_color}

                 colorPickerBtnTextColorRef={this.props.colorPickerBtnTextColorRef}
                 showColorPickerBtnTextColor = {this.props.show_color_picker_btn_text_color}
                 btnTextColor={this.props.btn_text_color}
                 

                 colorPickerH1ColorRef={this.props.colorPickerH1ColorRef}
                 showColorPickerH1Color={this.props.show_color_picker_h1_color}

                 colorPickerH2ColorRef={this.props.colorPickerH2ColorRef}
                 showColorPickerH2Color={this.props.show_color_picker_h2_color}
                 h2Color={this.props.h2_color}

                 colorPickerLogoColorRef={this.props.colorPickerLogoColorRef}
                 showColorPickerLogoColor={this.props.show_color_picker_logo_color}
                 logoColor={this.props.logo_color}


                    /> 

            <div className='editBlock'>  
                 <div className='whiteBlockTitle'>
                        <BeautifulCircleIcon/>
                            <div className='whiteBlockTitleSpan'>
                                Редактирование чат-бота и виджета
                            </div>
                        </div>
            <div className= 'inputsBlock'>
                        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Загрузите фото, которое будет показываться на сайте при просмотре с большого экрана(ПК, ноутбук и т.д.). Рекомендуемое соотношение сторон высота/ширина = 1,15
                    
                    </div>
        
                    <div onClick={(e) => {
                            this.refFileInputBigImg.current.click()
                        }}  className='inputsBlock_block_addPhoto'>
                        { this.props.big_img_src == null ? 
                        <span className='plusIcon'> <span className='plusIconSpan'>+</span> </span> 
                        : 
                        <img src={this.props.big_img_src}/>} 
                    </div>
                    
                    <input onChange={this.props.handleInputChange_bigImg} 
                    className='hidden' 
                    ref={this.refFileInputBigImg} 
                    type='file' />
        
            </div>
        
        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Загрузите фото, которое будет показываться на сайте при просмотре с телефона.
                   <span onClick={this.props.ClearPhotoMobile} className="clearPhotoSpan">Убрать фотографию в мобильной версии</span> 
                    </div>
        
                    <div onClick={(e) => {
                            this.refFileInputSmallImg.current.click()
                        }}  className='inputsBlock_block_addPhoto'>
                        { this.props.small_img_src == null ? 
                        <span className='plusIcon'> <span className='plusIconSpan'>+</span> </span> 
                        : 
                        <img src={this.props.small_img_src}/>} 
                    </div>
                    
                    <input onChange={this.props.handleInputChange_smallImg} className='hidden' ref={this.refFileInputSmallImg} type='file' />
        
            </div>
        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Введите текст, который выдается пользователю после проверки подписки(промокод или ссылка 
                    на полезный материал).
                    </div>
        
                    <textarea
                        onChange={this.props.updatePrize} 
                        value={this.props.prize} 
                        style={{height: '5.5em'}}> 
        
                    </textarea>
        
        
            </div>
            {/*<div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label'>
        
                    Назовите страницу, чтобы проверять статистику
                    </div>
        
                    <input type='text' />
        
        
                </div> */ }
        
        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                    Введите заголовок страницы
                    </div>
        
                    <textarea  
                    onChange={this.props.updateHeader} 
                     value={this.props.header_text} 
                      style={{height: '5.5em'}}> 
        
                    </textarea>
        
        
            </div>
        
            <div className= 'inputsBlock_block' >
                    <div className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                        Введите основной текст
                    </div>
        
                    <textarea onChange={this.props.updateMain} value={this.props.main_text} style={{height: '10em'}}> 
        
                    </textarea>
        
        
            </div>
            
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label whiteBlockTextInputBlock_label'>
        
                        Через сколько секунд после открытия сайта показывать виджет:
                    </div>
        
                    <input value={this.props.timeout} onChange={this.props.updateTimeout} type='number' min='0' max='30' />
        
        
            </div>
            
            
            <div className= 'inputsBlock_block saveBlock'>
                    {this.state.showButton ? <a href='#'  
                    onClick={(e) => {
                        this.props.setShowPreview(e, true)
                    }
                    } className='whiteBlockButton showButton'> Посмотреть </a> : null}
                    <a href='#' onClick={this.props.doSave} className='whiteBlockButton'>Сохранить</a>
                    {/*<div className="finishButton">
                            <a href='#'> Завершить редактирование </a>
                        </div> */}
                    
            </div>
            
        
            </div>  
            </div>
        
        </div>
            
        )
                
    }
}